import { capitalize } from "../utils";
import { getItemHighlight, getSecondaryHighlight, space } from "./utils";

export function getCaseItemTemplate(item, html) {
  return html` <div class="aa-ItemWrapper">
    <div class="aa-ItemContent">
      <div class="aa-ItemIcon aa-ItemIcon--alignTop">
        <svg
          aria-hidden="true"
          focusable="false"
          data-prefix="fas"
          data-icon="cart-shopping"
          class="svg-inline--fa fa-cart-shopping "
          role="img"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 576 512"
          height="24"
          width="24"
        >
          <path
            fill="currentColor"
            d="M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48H76.1l60.3 316.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24-10.7 24-24s-10.7-24-24-24H179.9l-9.1-48h317c14.3 0 26.9-9.5 30.8-23.3l54-192C578.3 52.3 563 32 541.8 32H122l-2.4-12.5C117.4 8.2 107.5 0 96 0H24zM176 512c26.5 0 48-21.5 48-48s-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48zm336-48c0-26.5-21.5-48-48-48s-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48z"
          ></path>
        </svg>
      </div>
      <div class="aa-ItemContentBody">
        <div class="aa-ItemContentTitle">
          ${capitalize(
            item.document["case_item.type"].replace("-", " ")
          )}:${space(html)}
          ${getItemHighlight(html, item, "device_definition.name", "no device")}
        </div>
        <div class="aa-ItemContentDescription">
          ${getSecondaryHighlight(html, item, "case_item.identifier")} CaseItem
          Status: ${item.document["case_item.status"]}

          <span class="orgid label label-default"
            >Org ID: ${item.document["case_item.organisation_id"]}</span
          >
          <span class="text-danger ml-1">
            (${item.document["case_item.organisation_name"]})</span
          >
        </div>
      </div>
    </div>
  </div>`;
}
